import { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Theme } from "./theme.model";

export default function useTheme(): Theme {
    const theme = useContext(ThemeContext) as Theme;
    return theme;
}
